import { api } from '@/api';
import { message } from 'ant-design-vue';

export default {
  namespaced: true,
  state: {
    isLoading: false,
    schemaVersion: '',
    current: {
      isLoading: false,
    },
    currentLanding: {
      id: null,
      widget_branding_id: null,
      logo: null,
      color: null,
      dealer_emails: [],
      company_url: null,
      language: 'en',
      create_bitrix_leads: false,
      payment_enabled: false,
      telegram_chat_id: null,
      webhook_ids: [],
      tariffs: [],
      landing_style: null,
      landing_params: null,
    },
    currentTab: 'branding',
  },
  mutations: {
    setLoading(state, loading) {
      state.isLoading = loading;
    },
    setBrandingData(state, data) {
      state.current = {
        ...state.current,
        ...data,
      };
      if (data.landing) {
        state.currentLanding = data.landing;
        state.currentLanding.dealer_emails = data.landing.dealer_emails || [];
        state.currentLanding.tariffs = data.landing?.tariffs || [];
        state.currentLanding.webhook_ids = (data.landing?.webhooks || []).map((webhook) => webhook.id);
      }
    },
    setSchemaVersion(state, version) {
      state.schemaVersion = version;
    },
  },
  actions: {
    async getBranding(store, id) {
      store.commit('setLoading', true);

      return api.getBranding(id).then((branding) => {
        store.commit('setLoading', false);
        branding = branding?.data;

        if (branding) {
          store.commit('setBrandingData', branding);
          return branding;
        }

        message.error({
          content: 'Branding not found',
          duration: 5,
        }).then((r) => {
          console.error(r);
        });

        return null;
      });
    },
  },
};
